import { Link } from "wouter";
import { Zap } from "lucide-react";

export function Footer() {
  return (
    <footer className="py-14 border-t border-border/40 bg-background">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10 mb-12">
          <div className="col-span-2 md:col-span-1">
            <Link href="/" className="inline-block cursor-pointer mb-4">
              <img src={`${import.meta.env.BASE_URL}harmcheck-logo-360.webp`} alt="HarmCheck logo" width="180" height="36" className="h-9 w-auto" />
            </Link>
            <p className="text-sm text-white leading-relaxed">
              Communication compliance for investment banks, legal firms, and regulated enterprises.
            </p>
          </div>

          <div>
            <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-4">Solutions</div>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li><Link href="/active-listening" className="hover:text-foreground transition-colors">Active Listening™</Link></li>
              <li><Link href="/rapid-deploy" className="hover:text-foreground transition-colors">Rapid Deploy™</Link></li>
              <li><a href="#restricted-list" className="hover:text-foreground transition-colors">Restricted List</a></li>
              <li><a href="#classifiers" className="hover:text-foreground transition-colors">Fair Lending</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-4">Resources</div>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li><Link href="/case-studies" className="hover:text-foreground transition-colors">Case Studies</Link></li>
              <li><a href="/faqs" className="hover:text-foreground transition-colors">FAQs</a></li>
              <li><a href="#" className="hover:text-foreground transition-colors">Blog</a></li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-4">Company</div>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li><a href="/about" className="hover:text-foreground transition-colors">About</a></li>
              <li><Link href="/trust-security" className="hover:text-foreground transition-colors">Trust & Security</Link></li>
              <li><Link href="/support" className="hover:text-foreground transition-colors">Support</Link></li>
              <li><a href="/book-a-demo" className="hover:text-foreground transition-colors">Request a Demo</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border/40 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Alphy Inc. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-xs text-muted-foreground">
            <a href="/privacy-policy" className="hover:text-foreground transition-colors">Privacy Policy</a>
            <a href="/terms-of-service" className="hover:text-foreground transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
